import { render, staticRenderFns } from "./BasePageHeader.vue?vue&type=template&id=601077c0"
import script from "./BasePageHeader.vue?vue&type=script&lang=js"
export * from "./BasePageHeader.vue?vue&type=script&lang=js"
import style0 from "./BasePageHeader.vue?vue&type=style&index=0&id=601077c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports